import styled from "vue-styled-components";

export const Content = styled.div`
    .modal {
        z-index: 5000;
        .modal-header {
            border: none;

            h2 {
                margin: 0 0 1.4rem;
            }
        }

        span {
            font-size: 1.35rem;
            display: block;
            margin-bottom: 1.8rem;
        }

        button {
            margin-bottom: 1rem;
            float: right;
        }
    }
`;
